import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom'
import { Input, Button, Table, Select, DatePicker, Space, Radio, Form, message } from 'antd'
import Modal from "antd/lib/modal/Modal"
import TextArea from "antd/lib/input/TextArea"
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from '../../tool/axios'
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    performance_id: string | undefined
    store_id: string | undefined
    nursing_name: string | undefined
    nursing_phone: string | undefined
    performanceDay: any
    performance_start_date: string | undefined
    performance_end_date: string | undefined
    review_status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function () {

    let { id }: { id: string } = useParams()

    let fetchOtherParamsTmpl: fetchParams = {
        performance_id: undefined,
        store_id: undefined,
        nursing_name: undefined,
        nursing_phone: undefined,
        performanceDay: null,
        performance_start_date: undefined,
        performance_end_date: undefined,
        review_status: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    const [reviewForm] = Form.useForm()
    const [batchReviewForm] = Form.useForm()

    const [recordId, setRecordId] = useState<string>('')
    const [selectIDs, setSelectIDs] = useState<string[]>([])

    const [passType, setPassType] = useState<number | undefined>(undefined)
    const [showReviewVisible, setShowReviewVisible] = useState<boolean>(false)

    const [batchPassType, setBatchPassType] = useState<number | undefined>(undefined)
    const [showBatchReviewVisible, setShowBatchReviewVisible] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        params.performance_id = id;

        handleDate(params, 'performanceDay', ['performance_start_date', 'performance_end_date'])

        axiosTable.get('/yuesao_center/manage/performance_info/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const rowSelectChange = (e: any) => {
        setSelectIDs(e)
    }

    const batchReview = () => {
        if (selectIDs.length === 0) {
            message.error('至少选择一条数据')
            return
        }

        setShowBatchReviewVisible(true)
    }

    const handlePassChange = (e: RadioChangeEvent) => {
        setPassType(e.target.value)
    }

    const confirmReview = (value: any) => {
        baseAxiosComplete.post('/yuesao_center/manage/performance/review', {
            performance_id: recordId,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams })
                setShowReviewVisible(false)
            }
        })
    }

    const handleBatchPassChange = (e: RadioChangeEvent) => {
        setBatchPassType(e.target.value)
    }

    const confirmBatchReview = (value: any) => {
        baseAxiosComplete.post('/yuesao_center/manage/performance/batch_review', {
            id_arr: selectIDs,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams })
                setShowBatchReviewVisible(false)
                setSelectIDs([])
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效管理 */}
        <BreadCrumb position={['月嫂中心', '月嫂绩效管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.nursing_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.nursing_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_phone') }} />

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["绩效开始日期", "绩效结束日期"]}
                    value={fetchOtherParams.performanceDay}
                    onChange={(v: any) => { handleChange(v, 'performanceDay') }}
                />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核状态" value={fetchOtherParams.review_status} onChange={(value: number) => { handleChange(value, 'review_status') }}  >
                    <Option value="0">待审核</Option>
                    <Option value="1">审核通过</Option>
                    <Option value="2">审核不通过</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { batchReview() }}>批量审核</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} rowSelection={{ onChange: rowSelectChange, selectedRowKeys: selectIDs }} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="performance_id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {record.review_status === 0 && <Button size="small" onClick={() => {
                                setRecordId(record.performance_id)
                                setShowReviewVisible(true)
                            }} >审核</Button>}
                        </Space>)
                    }}
                />

                <Column fixed title="门店名称" dataIndex="store_name" key="store_name" />
                <Column fixed title="员工名称" dataIndex="nursing_name" key="nursing_name" />
                <Column fixed title="员工手机号" dataIndex="nursing_phone" key="nursing_phone" />
                <Column fixed title="绩效日期" dataIndex="performance_date" key="performance_date" />
                <Column title="奖励金额" dataIndex="reward_amount" key="reward_amount" />
                <Column title="扣罚金额" dataIndex="penalty_amount" key="penalty_amount" />
                <Column title="实际奖惩金额" dataIndex="reward_penalty_amount" key="reward_penalty_amount" />
                <Column title="奖惩原因" dataIndex="reward_penalty_reason" key="reward_penalty_reason" />
                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
                <Column title="审核时间" dataIndex="review_time" key="review_time" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效管理 -> 审核 */}
        <Modal title="审核月嫂绩效" visible={showReviewVisible} footer={false} width="400px" onCancel={() => { setShowReviewVisible(false) }}>
            <Form form={reviewForm} onFinish={confirmReview} >
                <Form.Item style={{ marginTop: 8, marginBottom: 8 }} label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
                    <Radio.Group onChange={handlePassChange} value={passType}>
                        <Radio value={1}>通过</Radio>
                        <Radio value={2}>不通过</Radio>
                    </Radio.Group>
                </Form.Item>

                {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
                    <TextArea style={{ height: 80 }} />
                </Form.Item>}

                <Form.Item wrapperCol={{ span: 12, offset: 0 }}>
                    <Button type="primary" htmlType="submit">提交审核</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效管理 -> 批量审核 */}
        <Modal title="批量审核绩效" visible={showBatchReviewVisible} footer={false} width="400px" onCancel={() => { setShowBatchReviewVisible(false) }}>
            <Form form={batchReviewForm} onFinish={confirmBatchReview} >
                <Form.Item style={{ marginTop: 8, marginBottom: 8 }} label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
                    <Radio.Group onChange={handleBatchPassChange} value={passType}>
                        <Radio value={1}>通过</Radio>
                        <Radio value={2}>不通过</Radio>
                    </Radio.Group>
                </Form.Item>

                {batchPassType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
                    <TextArea style={{ height: 80 }} />
                </Form.Item>}

                <Form.Item wrapperCol={{ span: 12, offset: 0 }}>
                    <Button type="primary" htmlType="submit">提交审核</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div >)
}  